/* eslint-disable import/prefer-default-export */
export const liveChatLicense = "9423850"
